<template>
    <a
        v-if="href"
        class="link"
        :href="href"
        :target="target"
        :rel="rel"
        :onClick="() => onClick && onClick()">
        <span class="link-inner">
            <span>{{ label }}</span>
            <Icon
                v-if="icon && target === '_blank'"
                :type="icon"
                :rotate="iconRotate"
                :tooltip="tooltip"
                size="xs" />
        </span>
    </a>
</template>

<script lang="ts">
    import { PropType, computed, defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { Target } from './Link.interfaces';
    import { Type as IconType } from '../Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'Link',
        methods: { t },
        components: { Icon },
        props: {
            href: String,
            label: String,
            target: {
                type: String as PropType<Target>,
                default: '_self',
            },
            rel: {
                type: String,
                default: 'noopener noreferrer',
            },
            disabled: Boolean,
            icon: {
                type: String as PropType<IconType | null>,
                default: 'External',
            },
            iconRotate: Number,
            onClick: Function,
        },
        setup(props) {
            const tooltip = computed<string | undefined>(() => {
                return props.target === '_blank'
                    ? t({ key: 'shared.opens_in_new_tab' })
                    : undefined;
            });

            return {
                tooltip,
            };
        },
    });
</script>

<style lang="scss">
    @forward './Link.scss';
</style>
